 
import { Get, Post } from "../Request/Api";

export default {
  state: {
    Testimonials: [],
  },
  getters: {
    GetTestimonial(state : any) {
      return state.Testimonials;
    },
  },
  actions: {
    async CreateTestimonial({ commit }: any, payload: any) {
  
      return await Post("Testimonial/AddTestimonial", payload).then((res: any) => {
        return res.data;
      });
    },
    async GetTestimonial({ commit}: any, payload :any) {
      return await Get( 
        `Testimonial/GetTestimonials?page=${payload.page}&pageSize=${payload.pageSize}&search=${payload.search}&filter=${payload.filter ? payload.filter : []}` 
      ).then((res: any) => {
        commit("SetAllTestimonials", res.data.Data.Data);
        return res.data.Data;
      });
    },  
  },
  mutations: {
    SetAllTestimonials(state :any, payload : any) {
      state.Testimonials = payload;
    },
  },  
};
